export enum OpportunityPriceListBusinessDevelopmentStatusOption {
  AWAITING_ACTION = 'ff5d4cf7-dd58-4c08-9883-66763b359726',
  BACK_TO_SALESMAN = '00949d9f-12bf-4530-895d-777ab1912f3a',
  COMPLETED = '2330bc8d-a395-45d5-a1a2-d5149b096b8e',
  USER_ASSIGNED = 'fe77d091-bfa5-4879-bdb4-eba82c148096',
}
